<template>
  <div>
    <PageAppBar>Rounds</PageAppBar>
    <div v-if="!message" class="page-content header-clear-small">
      <div class="text text-center ml-auto mr-4 align-self-center" v-if="!Object.keys(rounds).length">
        <mushonga></mushonga>
      </div>
      <div v-else-if="!rounds.data">
        No rounds projects registered so far.
      </div>
      <div v-else v-for="round in rounds.data.data" :key="(round.id)">
        <div>
          <div class="card card-style mb-3">
            <div class="d-flex">
              <div class="pl-3 ml-2">
                <h1 class="pt-4">{{ round.project }}</h1>
                <p class="font-12 opacity-40 mt-n2 mb-2 text" >Description: {{ round.details }}</p>
                <p class="font-12 opacity-40 mt-n2 mb-2 text">Round Contribution: {{ round.amount }}</p>
<!--                <p @click="joinRoundProject(round)" class="font-11 opacity-50 mt-n2 mb-4">Join scheme</p>-->
                </div>
              <div class="ml-auto mr-4 align-self-center">
                <i @click="joinRoundProject(round)" class="fa fa-plus-circle pri-color  fa-3x mt-4 mb-4"></i>
              </div>
            </div>
            <router-link :to="'/round/'+round.id"  class="btn btn-m btn-full mb-1 rounded-sm text-uppercase font-900 border-yellow pri-color cbg-theme">More Details</router-link>
          </div>
        </div>
      </div>
      <FooterBar></FooterBar>
    </div>
    <div v-else-if="message.length" class="page-content header-clear-small">
      <div v-if="message.length">
        {{message}}
      </div>
      <div class="card card-style">
        <div class="content">
          <h1>TBD ROUNDS</h1>
          <p class="color-highlight font-12 mt-n3 pt-1 mb-2 " >You have joined TRP{{round.id}}</p>
          <p v-if="Object.keys(round).length" >To begin you have to start making your contributions of ${{round.amount}}</p>
        </div>
      </div>
      <FooterBar> </FooterBar>
    </div>
  </div>
</template>

<script>
import FooterBar from "@/components/FooterBar";
import PageAppBar from "@/components/PageAppBar";
// import Google from "vue-loading-spinner/src/components/Google";

import axios from "axios";
import global from "@/mixins/global";
export default {
  components: {PageAppBar, FooterBar},
  mixins: [global],
  mounted() {
    axios.get(this.base_url+"rounds", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{this.rounds = response}).catch(error=>{this.error = error})
  },
  data(){
    return {
      rounds: [],
      round: {}
    }
  },
  methods: {
    joinRoundProject(round){
      this.round = round
      axios.post(this.base_url+"rounds/join/"+round.id,{},
          this.requestAuthHeaderToken(localStorage.getItem("token")
          )).then(response=>{
        this.message = response.data.message
      }).catch(error=>{
        this.error = error
      })
    }
  },
  computed: {
      pageTitle(){
          return this.$route.path
      }
  }
}
</script>

<style>
    .header-clear-small {
        padding-top: 60px;
    }
    .text-center{
      align-items: center;
    }
    .pri-color{
      color:#DA4453;
    }
    .text{
      color: #474A48;
      font-family: sans-serif;
      font-weight: 500;
    }
    
</style>